import { createStructuredSelector } from 'reselect';
import { userDataSelector } from '@selectors/global';
import {
  applicationLookupModalOpenSelector,
  applicationLookupModalModeSelector,
  applicationLookupModalStateSelector,
  applicationLookupModalDataSelector,
  applicationLookupModalPropertyIdSelector,
} from '../../selectors/exemption';
import { preferenceSelector } from '../../selectors/global';

export default createStructuredSelector({
  data: applicationLookupModalDataSelector,
  modalOpen: applicationLookupModalOpenSelector,
  mode: applicationLookupModalModeSelector,
  preference: preferenceSelector,
  propertyId: applicationLookupModalPropertyIdSelector,
  state: applicationLookupModalStateSelector,
  userData: userDataSelector,
});
